module.exports = __webpack_public_path__ + "assets/img/user-4.4e478253.jpg";